import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import Input from '../input/Input';
import Button from '../button/Button';
import { submitDocumentDownload } from './service';
import * as classes from './DownloadForm.module.scss';
import Loader from '../loader/Loader';

const createValidator = () => {
  return yup.object().shape({
    password: yup.string().required('Please enter a password.')
  });
};

const useDocumentHash = () => {
  const [documentHash, setDocumentHash] = useState();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const hash = decodeURIComponent(params.get('documentHash'));

    setDocumentHash(hash);
  }, []);

  return documentHash;
};

const formatErrorMessage = (message) => {
  switch (message) {
    case 'incorrect_password':
      return 'Incorrect password. Please try again.';
    case 'expired_error':
      return 'Sorry, your link has expired. Get in touch with our Customer Support team to request another.';
    case 'attempts_error':
      return 'Sorry, you have entered an incorrect document password too many times. Please get in touch with our Customer Support team for assistance.';
    case 'revoked_error':
    case 'unknown_error':
    default:
      return 'Something went wrong. Try again later or get in touch with our Customer Support team.';
  }
};

const DownloadForm = () => {
  const [error, setError] = useState();
  const documentHash = useDocumentHash();
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting, isValid }
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(createValidator())
  });

  const onSubmit = (data) => {
    const payload = {
      password: data.password
    };

    if (documentHash.startsWith('$argon2d$')) {
      payload.documentHash = documentHash;
    } else {
      payload.hash = documentHash;
    }

    setError(null);

    submitDocumentDownload(payload).catch((err) => {
      const message = err?.response?.data?.message;
      setError(formatErrorMessage(message));
    });
  };

  if (!documentHash) {
    return (
      <div className={classes.error}>
        <p>Have you used the correct link?</p>
        <p>Please check the link and try again.</p>
      </div>
    );
  }

  return (
    <section className={classes.section} id="document-download-form">
      <form method="POST" className={classes.form} onSubmit={handleSubmit(onSubmit)}>
        <h3 className={classes.h3}>Please enter the password we sent by SMS (it's case sensitive!)</h3>
        <div className={classes.inputButton}>
          <Input id="dd-password" type="password" label="Password" error={errors?.password} {...register('password')} />
          {isSubmitting && <Loader />}
          <Button disabled={!isValid} className={classes.button}>
            Submit
          </Button>
        </div>

        {error ? <p>{error}</p> : null}
      </form>
    </section>
  );
};

export default DownloadForm;
